<template>
  <div v-if="isCarregado == false" class="fullbody" style="margin-top: 50px">
    <base-spinner></base-spinner>
  </div>
  <div
    v-if="this.categoriaDada != null && isCarregado == true"
    class="fullbody"
  >
    <div class="d-flex container justify-content-space-between">
      <h1>{{ categoriaDada[0].categoria }}</h1>
      <div id="margin" class="row">
        <p id="ordem" class="col">Ordenar por:</p>
        <select
          @change="onChange($event)"
          class="form-select d-inline col"
          style="width: fit-content"
          aria-label="select"
          v-model="ordenacao"
          id="orderby"
        >
          <option value="LAN%C3%87AMENTO" selected>LANÇAMENTO</option>
          <option value="MENOR%20PRE%C3%87O">MENOR PREÇO</option>
          <option value="MAIOR%20PRE%C3%87O">MAIOR PREÇO</option>
          <option value="MAIS%20VENDIDOS">MAIS VENDIDOS</option>
          <option value="MAIOR%20ESTOQUE">MAIOR ESTOQUE</option>
          <option value="MENOR%20ESTOQUE">MENOR ESTOQUE</option>
        </select>
      </div>
    </div>
    <hr />
    <img
      v-if="topovisibility"
      @click="top"
      id="back-to-top"
      src="../../public/totop.png"
      alt="voltar ao topo botão"
    />
    <div>
      <div class="container"></div>
      <div class="container">
        <ul style="padding: 0">
          <div v-if="isLoading == true" style="margin-top: 50px">
            <base-spinner></base-spinner>
          </div>
          <div class="row" v-if="!isCargando && !isLoading">
            <item-produto
              class="col-md col-6 p-1"
              v-for="produto in categoriaDada"
              :key="produto.nomeproduto"
              :nomeproduto="produto.nomeproduto"
              :url="produto.url"
              :detalhes="produto.detalhes"
              :preco="produto.preco"
              :saldo="produto.saldo"
              :codigo="produto.codigo"
              :referencia="produto.referencia"
            >
            </item-produto>
            <div
              class="d-flex justify-content-center my-4"
              style="margin-top: 50px !important"
              v-if="!isCargando && categoriaDada?.length"
            >
              <button
                class="btn btn-outline-primary mx-1"
                :disabled="paginaAtual === 0"
                @click="paginaAnterior"
              >
                Anterior
              </button>
              <span class="mx-2 align-self-center">
                Página {{ paginaVisivel }}</span
              >
              <button
                class="btn btn-outline-primary mx-1"
                :disabled="acabouProdutos"
                @click="proximaPagina"
              >
                Próximo
              </button>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
  <div v-if="this.categoriaDada == null && isCarregado == true" class="acabou">
    <h1>Ops...</h1>
    <hr />
    <p>Não temos produtos disponíveis desta categoria no momento.</p>
  </div>
  <AppFooter />
</template>

<script>
import ItemProduto from "../components/produtos/ItemProduto.vue";
import { mapState } from "vuex";
import router from "@/router";
import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    ItemProduto,
    AppFooter,
  },
  props: {
    tokenTipo: String,
    tokenLoja: String,
    tokenCategoria: String,
  },
  data() {
    return {
      ordenacao: "LAN%C3%87AMENTO",
      isCargando: false,
      isLoading: false,
      topovisibility: false,
      paginaAtual: 0,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("produtos", ["categoriaDada"]),
    ...mapState("produtos", ["categoria"]),
    ...mapState("produtos", ["isCarregado"]),

    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    categorianumber() {
      return this.$store.getters["loja/categoriaSelecionada"];
    },
    acabouProdutos() {
      return this.$store.getters["produtos/acabouprodutos"] === "acabou";
    },
    paginaVisivel() {
      return this.paginaAtual + 1;
    },
  },
  methods: {
    async carregarCategoriaSelecionada() {
      if (this.categoriaDada.length === 0 || this.categoriaDada.length === 4) {
        this.isCargando = true;
        await this.$store.dispatch("produtos/carregarCategoriaSelecionada", {
          ordem: this.ordenacao,
        });
        this.isCargando = false;
      }
    },
    async proximaPagina() {
      if (this.acabouProdutos) return;
      window.scrollTo({ top: 0, behavior: "smooth" });

      this.paginaAtual++;
      this.isLoading = true;
      await this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual);
      await this.carregarPaginaAtual();
      if (this.$store.getters["produtos/acabouprodutos"] === "acabou") {
        this.paginaAtual--; // Revert to last valid page
        await this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual);
      }
      this.isLoading = false;
    },
    async paginaAnterior() {
      if (this.paginaAtual > 0) {
        this.isLoading = true;
        window.scrollTo({ top: 0, behavior: "smooth" });

        this.paginaAtual--;
        await this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual);
        await this.carregarPaginaAtual();
        this.isLoading = false;
      }
    },
    async carregarPaginaAtual() {
      this.isCargando = true;

      await this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual); 
      await this.$store.dispatch("produtos/carregarCategoriaSelecionada", {
        ordem: this.ordenacao,
      });

      this.isCargando = false;
    },
    async onChange(event) {
      this.ordenacao = event.target.value;
      this.$store.dispatch("produtos/isProdutoLoading");

      await this.$store.dispatch("loja/resetPaginacao");
      await this.$store.dispatch("produtos/resetAcabouProdutos");
      await this.$store.dispatch("produtos/resetProdutos");
      await this.$store.dispatch("produtos/carregarCategoriaSelecionada", {
        ordem: this.ordenacao,
      });

      this.$nextTick(() => {
        this.$store.dispatch("produtos/isProdutoReady");
      });
    },
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.carregarRodape();
    this.carregarCategorias();
    this.paginaAtual = 0;
    this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual);
  },
  watch: {
    async categorianumber(newCategory, oldCategory) {
      if (newCategory != oldCategory) {
        this.paginaAtual = 0;
        await this.$store.dispatch("loja/setPaginaAtual", this.paginaAtual);
        this.$store.dispatch("produtos/isProdutoLoading");

        await this.$store.dispatch("loja/resetPaginacao");
        await this.$store.dispatch("produtos/resetProdutos");
        await this.$store.dispatch("produtos/resetAcabouProdutos");
        await this.$store.dispatch("produtos/carregarCategoriaSelecionada", {
          ordem: this.ordenacao,
        });

        this.$store.dispatch("produtos/isProdutoReady");
      }
    },
  },
  mounted() {
    if (
      router.currentRoute.value.fullPath ==
      "/" +
        this.tipo +
        "/" +
        this.loja +
        "/" +
        "produtos/categorias/" +
        this.categoria
    ) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 1145) {
          this.topovisibility = true;
        } else {
          this.topovisibility = false;
        }
      });
    }

    if (this.tokenLoja === "tayle") {
      this.ordenacao = "MAIOR%20ESTOQUE";
    }
    this.carregarCategoriaSelecionada();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");
@import "@/styles/variables.css";

#orderby:focus {
  border-color: var(--primary-color);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #13433a;
}

h1 {
  color: var(--primary-color);
  margin: 40px;
}

#back-to-top {
  position: fixed;
  width: 80px;
  bottom: 0%;
  right: 0%;
  cursor: pointer;
}

.fullbody {
  min-height: 100vh;
}



ul {
  list-style: none;
  margin: 2rem auto;
}

div {
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 85rem;
}

.acabou {
  min-height: 100vh;
}
.acabou > p {
  margin-bottom: 100px;
  text-align: center;
  font-size: 20px;
}

div.search {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 1rem;
  margin: 2rem auto;
  width: 60%;
  text-align: center;
}

div.search > img {
  width: 5%;
}

img {
  margin-left: 1rem;
}

input {
  margin: 0;
  margin: auto;
  width: 90%;
}

button:hover,
button:active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

button {
  font: inherit;
  cursor: pointer;
  background-color: var(--primary-color);
  color: white;
  border: 1px solid var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}
</style>
